import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@dc/ui";
import { ChannelProvider } from "ably/react";
import { useMe } from "@/hooks/useMe";
import { UserChannelContext } from "./UserChannelProvider.context";
const channelPrefix = "app:user:";
export const UserChannelProvider = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    me,
    isLoading,
    error
  } = useMe();
  const channelName = me?.data.id ? `${channelPrefix}${me.data.id}` : undefined;
  const showLoadingSpinner = isLoading && !me?.data.id && !error;
  if (showLoadingSpinner) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex min-h-dvh items-center justify-center"><Spinner data-testid="spinner" size="lg" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!channelName) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        channelName: undefined
      };
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== children) {
      t2 = <UserChannelContext.Provider value={t1}>{children}</UserChannelContext.Provider>;
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== channelName) {
    t1 = {
      channelName
    };
    $[4] = channelName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== channelName || $[7] !== children) {
    t2 = <ChannelProvider channelName={channelName}>{children}</ChannelProvider>;
    $[6] = channelName;
    $[7] = children;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <UserChannelContext.Provider value={t1}>{t2}</UserChannelContext.Provider>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};